export default class QaiScorecardChallengeNoteViewModel {
    public questionId: number
    public note: string = ''
    public type: QaiScorecardChallengeNoteType = QaiScorecardChallengeNoteType.normal
    public aiTemplateVersion: number

    public constructor(questionId: number, aiTemplateVersion: number) {
        this.questionId = questionId;
        this.aiTemplateVersion = aiTemplateVersion
    }
}

export enum QaiScorecardChallengeNoteType {
    normal = 'Normal',
    escalated = 'Escalation'
}